module.exports = __webpack_public_path__ + "static/media/boat-img-23.e321e14e.jpg";